import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { createCase } from '../../adapters/caseResolution';
import SuccessStatus, { ErrorStatus } from '../../components/FormStatus';
import { TextAreaInput, InputField, FileInput, SelectOptionField } from '../../components/Input';
import { ClaimantModal } from '../../components/user/ClaimantModel';
import DefendantModal from '../../components/user/DefendantModal';
import { creatCaseValidation } from '../../requests/createCase';
import { truncateString } from '../../utils/methods';


export default function CreateCase() {

    const navigate = useNavigate();

    const [ showNotice, setShowNotice ] = useState(true);
    // const [ addClaimant, setAddClaimant ] = useState(true);
    const [addClaimant, setAddClaimant] = useState(false);
    const [addDefendant, setAddDefendant] = useState(false);
    const [claimants, setClaimants] = useState([]);
    const [defendants, setDefendants] = useState([]);
    const [monetaryClaim, setMonetaryClaim] = useState(0)
    const categories = ["Employer/Employee", "Business to Business", "Business to Consumer", "Consumer to Consumer"];
    const [facts, setFacts] = useState({
        industry: '',
        description: '',
        reliefs: '',
        category: categories[0],
    });

    const [banta,setBanta ] = useState(0);

    const [errors, setErrors ] = useState([]);
    const [selectedClaimant, setSelectedClaimant] = useState({})
    const [selectedDefendant, setSelectedDefendant] = useState({})
    const [documents, setDocumnets] = useState([]);
    const [submisionStatus, setSubmisionStatus ] = useState(false);
    const [processing, setProcessing] = useState(false);


    const handleFactInputChamge = (value, name) => {
        setErrors([]);
        facts[name] = value;
        setFacts(facts)
    }

    const handleAddedDocument = (value) => {
        let files = [...documents, ...value]
        setDocumnets(files);
    }

    const handleRemovedDocument = (index) => {
        const fileListArr = Array.from(documents)
        fileListArr.splice(index, 1)
        setDocumnets(fileListArr)
    }

    const showClaimantModal = (e, data) => {
        e.preventDefault();
        setSelectedClaimant(data);
        setAddClaimant(true);
    }

    const showDefendantModal = (e, data) => {
        e.preventDefault();
        setSelectedDefendant(data)
        setAddDefendant(true)
    }

    const closeClaimantModal =  () => {
        setAddClaimant(false);
    }

    const closeDefendantModal = () => {
        setAddDefendant(false);
    }
    const submitClaimant = (data) => {
        let recordExists = Object.entries(selectedClaimant).length > 0 ;
        if (!recordExists){
            claimants.push(data);
            setClaimants(claimants)
        }else{
            const dataIndex = claimants.findIndex((c) => c === selectedClaimant)
            claimants[dataIndex] = data;
            setClaimants(claimants);
            setSelectedClaimant({});
        }
    }

    const submitDefendant = (data) => {
        let recordExists = Object.entries(setSelectedDefendant).length > 0;
        if (!recordExists) {
            defendants.push(data);
            setDefendants(defendants)
        } else {
            const dataIndex = defendants.findIndex((c) => c === selectedClaimant)
            defendants[dataIndex] = data;
            setDefendants(defendants);
            selectedDefendant({});
        }
    }


    const createCaseSubmit = () => {
        if(processing) return;
        // if (documents.length < 0){
        //     setErrors(['submit at least one documnet to back your claim'])
        //     return ;
        // }
        setProcessing(true);
        creatCaseValidation.validate({
            claimants,
            facts,
            defendants,
            monetaryClaim,
            banta
        }).then(async () => {
            try {
                
                const data = {
                    claimants,
                    defendants,
                    facts,
                    evidences: documents,
                    monetaryClaim,
                    batna: banta,
                };

                await createCase(data).then((res) => {
                    if (res.status === 200) {
                        setSubmisionStatus(true);
                        navigate('/account/dashboard', { replace: true });
                        // setTimeout(() => {
                        //     setSubmisionStatus(false);
                        // }, 3000)
                    } else {
                        setErrors(['Case creation failed!'])
                    }
                    setProcessing(false);
                })
            } catch (e) {
                setErrors(['Case creation failed!'])
            }
        }).catch((e) => {
            setProcessing(false);
            setErrors(e.errors);
        })
    }

    

  return (
    <div className="relative">
          {showNotice  && <div className="fixed z-30 bottom-0 w-full animate__animated animate__fadeInUp">
              <div className="mt-4 text-gray-900 w-full md:w-3/5 mx-auto xl:w-2/5 text-justify bg-white py-10 px-6 rounded-t-xl relative">
                  <button onClick={() => setShowNotice(false)} className="absolute top-3 right-4">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                          <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z" clipRule="evenodd" />
                      </svg>
                  </button>
                  <p className="text-xs">
                      <span className="font-semibold">Please note</span> that U-Resolve® charges a fee of 2% of your claimed amount. This would be calculated at the point of commencement of the resolution process, that is, at the time of acceptance of the invitation to resolution by the defendant. You, as the Claimant, will need to pay this assessed amount to proceed.
                  </p>
              </div>
        </div>}
        <div className="wrapper-2 animate__animated animate__fadeIn">
            <div className="gradient-bg relative rounded-b-lg py-12 mb-16 px-8 flex lg:items-center lg:flex-row flex-col justify-start lg:justify-between items-start gap-4">
                <div>
                    <h1 className="font-fira xl:text-2xl text-xl">Create case</h1>
                    <p className="text-xs lg:text-sm font-taviraj">Resolve your issues easily and risk free</p>
                </div>
                <Link to="/account/dashboard" className=" border-2 border-blue-900 px-4 py-2 gap-1 flex items-start hover:text-blue-900 rounded-lg text-gray-800 font-semibold text-xs left-8">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                            <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clipRule="evenodd" />
                        </svg>
                    </span>

                    <span>
                        Dashboard
                    </span>
                </Link>
            </div>

            <div className="px-1">
                <ErrorStatus errors={errors} />
                <SuccessStatus message="Case created successfully" showStatus={submisionStatus} />
            </div>

            <div className="px-6 md:px-0">
                <div className="mt-4 text-sm font-semibold">
                    To initiate a new case for resolution, kindly fill in the data fields below to the best of your ability.
                </div>

                <form onSubmit={(e) => {
                    e.preventDefault();
                    createCaseSubmit();
                }}>
                    <div className="mt-4 bg-gray-100 py-6 px-4 lg:px-8 rounded-lg border-2 border-gray-300">
                        <div className="flex py-6 border-b border-blue-800 gap-3 justify-between md:flex-row flex-col items-start">
                            <div className="md:w-3/6 w-full gap-2 flex md:flex-col flex-row md:justify-start justify-between md:items-start items-center">
                                <h4 className="text-sm font-semibold">
                                    Claimant(s)
                                </h4>

                                <button onClick={(e) => showClaimantModal(e, {})} className="bg-blue-800 flex gap-1 items-center hover:bg-blue-900 text-white py-2 px-4 rounded-lg text-xs font-semibold">
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                                            <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 9a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V15a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V9z" clipRule="evenodd" />
                                        </svg>
                                    </span>
                                    <span>
                                        Add Claimant
                                    </span>
                                </button>
                            </div>

                            <div className="md:w-3/6 w-full">
                                <ul className="rounded-lg">
                                    {claimants.map((cmt) => {
                                        return (<li key={claimants.indexOf(cmt)} className="py-4 px-4 hover:bg-gray-200 cursor-pointer border-gray-200 border-b" onClick={(e) => showClaimantModal(e, cmt)}>
                                            <div>
                                                <p className="font-semibold text-xs">
                                                    {cmt.name}
                                                </p>
                                                <p className="text-xs mt-1">
                                                    {cmt.email}
                                                </p>
                                            </div>
                                        </li>)
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className="flex mt-3 py-6 border-b border-blue-800 gap-3 justify-between md:flex-row flex-col items-start">
                            <div className="md:w-3/6 w-full gap-2 flex md:flex-col flex-row md:justify-start justify-between md:items-start items-center">
                                <h4 className="text-sm font-semibold">
                                    Fact of Case
                                </h4>
                            </div>

                            <div className="md:w-3/6 w-full">

                                  <SelectOptionField isRequired={true} placeholder="Category of Case" onChange={(e) => {
                                      setErrors([]);
                                      handleFactInputChamge(e.target.value, 'category')
                                  }} name="notification" defaultValue={facts.category} id="category" label="Category of case" options={categories} />

                                {/* <InputField
                                    onChange={(e) => {
                                        setErrors([]);
                                        handleFactInputChamge(e.target.value, 'industry')
                                    }}
                                    isRequired={true} type="text" placeholder="Industry of Case" name="industry" defaultValue={facts.industry} label="Industry of Case" /> */}

                                <TextAreaInput
                                    onChange={(e) => {
                                        setErrors([]);
                                        handleFactInputChamge(e.target.value, 'description')
                                    }}
                                    isRequired={true} placeholder="Succintly state your side of the story" name="industry" defaultValue={facts.description} label="Narration" />

                                <TextAreaInput
                                    onChange={(e) => {
                                        setErrors([]);
                                        handleFactInputChamge(e.target.value, 'reliefs')
                                    }}
                                    isRequired={true} placeholder="State the reliefs you are seeking through the resolution process" name="reliefs" defaultValue={facts.reliefs} label="Reliefs" />
                                    
                            </div>
                        </div>
                        <div className="flex mt-3 py-6 border-b border-blue-800 gap-3 justify-between md:flex-row flex-col items-start">
                            <div className="md:w-3/6 w-full gap-2 flex md:flex-col flex-row md:justify-start justify-between md:items-start items-center">
                                <h4 className="text-sm font-semibold">
                                    Monetary Claim
                                </h4>
                            </div>

                            <div className="md:w-3/6 w-full">
                                <InputField
                                    onChange={(e) => {
                                        setErrors([]);
                                        setMonetaryClaim(e.target.value)
                                    }}
                                    isRequired={false} type="text" id="monetaryClaim" placeholder="State the amount, in figure that you are claiming from the defendant" name="monetaryClaim" defaultValue={monetaryClaim} label="Claimed Amount" />
                            </div>
                        </div>
                        <div className="flex mt-3 py-6 border-b border-blue-800 gap-3 justify-between md:flex-row flex-col items-start">
                            <div className="md:w-3/6 w-full gap-2 flex md:flex-col flex-row md:justify-start justify-between md:items-start items-center">
                                <h4 className="text-sm font-semibold">
                                    BATNA
                                </h4>
                            </div>

                            <div className="md:w-3/6 w-full">
                                <InputField
                                    id="banta"
                                    onChange={(e) => {
                                        setErrors([]);
                                        setBanta(e.target.value)
                                    }}
                                    isRequired={false} type="text" placeholder="What sum are you willing to settle for" name="industry" defaultValue={banta} label="Settlement sum" />
                            </div>
                        </div>
                        <div className="flex mt-3 py-6 border-b border-blue-800 gap-3 justify-between md:flex-row flex-col items-start">
                            <div className="md:w-3/6 w-full gap-2 flex md:flex-col flex-row md:justify-start justify-between md:items-start items-center">
                                <h4 className="text-sm font-semibold">
                                    Documents/Evidences
                                </h4>
                            </div>

                            <div className="md:w-3/6 w-full">
                                <FileInput
                                    id="evidence"
                                    onChange={(e) => {
                                        setErrors([]);
                                        handleAddedDocument(e.target.files);
                                    }}
                                    multiple={true}
                                    isRequired={false} type="text" fileType=""  name="evidence" defaultValue={documents} label="Add Evidence" />


                                {Array.from(documents).map((file, index) => {
                                    let fileType = file['type'].split('/')[0];
                                    return (<div key={index} className="mt-4 mx-3 justify-between text-blue-800 bg-white rounded-lg py-3 px-4 flex items-center text-xs font-semibold gap-6">
                                        <div className="flex gap-3 items-center">
                                            <span>
                                                {fileType === 'image' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                                                    <path fillRule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z" clipRule="evenodd" />
                                                </svg>}

                                                {fileType === 'video' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                                                    <path d="M4.5 4.5a3 3 0 00-3 3v9a3 3 0 003 3h8.25a3 3 0 003-3v-9a3 3 0 00-3-3H4.5zM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06z" />
                                                </svg>}

                                                {fileType === 'application' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                                                    <path d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625z" />
                                                    <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
                                                </svg>}

                                                {fileType === 'text' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                                                    <path fillRule="evenodd" d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625zM7.5 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 017.5 15zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H8.25z" clipRule="evenodd" />
                                                    <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
                                                </svg>}
                                            </span>
                                            <span title={file['name']}>
                                                {truncateString(file['name'])}
                                            </span>
                                        </div>

                                        <button onClick={(e) => {
                                            e.preventDefault();
                                            handleRemovedDocument(index)
                                        }} className="text-red-800 hover:text-red-900">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                                                <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>)
                                })}

                                
                            </div>
                        </div>

                        <div className="flex py-6 border-b border-blue-800 gap-3 justify-between md:flex-row flex-col items-start">
                            <div className="md:w-3/6 w-full gap-2 flex flex-col md:justify-start justify-between md:items-start items-center">

                                <div>
                                    <h4 className="text-sm font-semibold">
                                        Defendants
                                    </h4>
                                    <p className="text-xs">
                                        The information you provide here will be used to send invitations to your opponent on the case. Please ensure that the information is correct. <br />
                                    </p>
                                </div>

                                <button onClick={(e) => showDefendantModal(e, {})} className="bg-blue-800 flex gap-1 items-center hover:bg-blue-900 text-white py-2 px-4 rounded-lg text-xs font-semibold">
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                                            <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 9a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V15a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V9z" clipRule="evenodd" />
                                        </svg>
                                    </span>
                                    <span>
                                        Add Defendant
                                    </span>
                                </button>
                            </div>

                            <div className="md:w-3/6 w-full">
                                <ul className="rounded-lg">
                                    {defendants.map((dnt) => {
                                        return (<li key={defendants.indexOf(dnt)} className="py-4 px-4 hover:bg-gray-200 cursor-pointer border-gray-200 border-b" onClick={(e) => showClaimantModal(e,dnt)}>
                                            <div>
                                                <p className="font-semibold text-xs">
                                                    {dnt.name}
                                                </p>
                                                <p className="text-xs mt-1">
                                                    {dnt.email}
                                                </p>
                                            </div>
                                        </li>)
                                    })}
                                </ul>
                            </div>
                        </div>

                        <div className="mt-4 py-8">
                            <button type="submit" disabled={processing} className="w-full md:w-1/3 hover:bg-blue-900 md:float-right py-3 px-6 text-center font-semibold bg-blue-800 text-white rounded-lg">{processing ? 'Please wait...' :'Submit'}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>


        {/* Claimant Modal */}
        {addClaimant && <ClaimantModal initState={selectedClaimant} onClose={closeClaimantModal} onSubmit={submitClaimant} title="Add Claimant"/>}
        {addDefendant  && <DefendantModal initState={selectedDefendant} onClose={closeDefendantModal} onSubmit={submitDefendant} />}
    </div>
    
  )
}



